import AdministrativePanelOptions from './AdministrativePanelOptions'
import SubMenu from './SubMenu'

const AdministrativePanel = () => (
    <SubMenu componentOptions={AdministrativePanelOptions} />
)

export default AdministrativePanel